"use strict";
import Vue from 'vue/dist/vue.common.js';
import VRListingItem  from '../components/v-r-listing-item';

const ShowMore = Vue.component('ts-show-more', {
  template: `
    <div>
      <ul class="RelatedResourcesStrata-list">

        <ts-vr-listing-item
        v-for="item in reducedItems"
        :key="item.table.id"
        :item="item">
        </ts-vr-listing-item>

      </ul>
      <div class="u-center u-mt4">
        <button @click="showAll" v-if="!active && listIsReduced" class="Button Button--blue Button--pill">
          <span>Show All</span>
        </button>
      </div>
    </div>
  `,

  data() {
    return {
      active: false
    };
  },

  computed: {
    reducedItems() {
      return (this.active && this.items.length > this.initItemsShown) ? this.items : this.items.slice(0, this.initItemsShown)
    },
    listIsReduced() {
      return this.items.length > this.initItemsShown ? true : false;
    }
  },

  props: {
    initItemsShown: {
      required: false,
      type: Number,
      default: 3
    },
    items: {
      required: false,
      type: Array
    }
  },

  mounted() {
  },

  methods: {
    showAll() {
      this.active = true;
    }
  }
});

export default ShowMore;